module.exports = __webpack_public_path__ + "img/hotdog-top-ma003.f9af9ba3.jpg";